export default __webpack_public_path__ + "static/media/Manual-6.212ef272.png";